import React from "react";
import { ReportingPageHome } from "components/ReportingPage";

const Cnt_Reports_Page: React.FC<any> = (props) => {
  return <ReportingPageHome/>
};

export default Cnt_Reports_Page;